import api from './api';
import { formatApiError, logError } from '../utils/errorHandler';
import { ENDPOINTS } from '../utils/constants';

/**
 * Fetch Squarespace online orders (employee only).
 *
 * @param {Object} filters
 * @param {string} filters.dateFrom           - YYYY-MM-DD start date
 * @param {string} filters.dateTo             - YYYY-MM-DD end date
 * @param {string} filters.fulfillmentStatus  - 'pending' | 'fulfilled' | ''
 * @param {string} filters.cursor             - Pagination cursor
 * @returns {Promise<{ orders, next_cursor, has_more }>}
 */
export const getSquarespaceOrders = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    if (filters.dateFrom)           params.append('date_from', filters.dateFrom);
    if (filters.dateTo)             params.append('date_to', filters.dateTo);
    if (filters.fulfillmentStatus)  params.append('fulfillment_status', filters.fulfillmentStatus);
    if (filters.cursor)             params.append('cursor', filters.cursor);

    const base = ENDPOINTS.ORDERS.SQUARESPACE;
    const qs   = params.toString();
    const url  = qs ? `${base}?${qs}` : base;

    const response = await api.get(url);
    return response.data;
  } catch (error) {
    logError('Get Squarespace orders', error);
    throw formatApiError(error);
  }
};
